"use strict";
'use es6'; // Prevent unwanted focus styles

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

require("../listeners/focusStylesListener");

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _classnames = _interopRequireDefault(require("classnames"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _memoWithDisplayName = _interopRequireDefault(require("../utils/memoWithDisplayName"));

var _validHref = _interopRequireDefault(require("../utils/propTypes/validHref"));

var _UnsafeUrl = require("../utils/UnsafeUrl");

var _Links = require("../utils/Links");

var _TabIndex = require("../utils/TabIndex");

var _LinkConstants = require("./LinkConstants");

var _UIIcon = _interopRequireDefault(require("../icon/UIIcon"));

var _UITruncateString = _interopRequireDefault(require("../text/UITruncateString"));

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  .private-table tr:not(:hover) .private-link:not(:focus) & {\n    visibility: hidden;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// Hide icon in tables, except on hover (#5679)
var truncatedExternalIconMixin = (0, _styledComponents.css)(_templateObject());
var DefaultExternalIcon = (0, _styledComponents.default)(function (props) {
  var __truncated = props.truncated,
      rest = (0, _objectWithoutProperties2.default)(props, ["truncated"]);
  return _react.default.createElement(_UIIcon.default, rest);
}).withConfig({
  displayName: "UILink__DefaultExternalIcon",
  componentId: "u098z8-0"
})(_templateObject2(), function (_ref) {
  var truncated = _ref.truncated;
  return truncated && truncatedExternalIconMixin;
});
var UILink = (0, _memoWithDisplayName.default)('UILink', function (props) {
  var children = props.children,
      className = props.className,
      disabled = props.disabled,
      external = props.external,
      ExternalIcon = props.ExternalIcon,
      href = props.href,
      iconProps = props.iconProps,
      linkRef = props.linkRef,
      _onClick = props.onClick,
      _onKeyDown = props.onKeyDown,
      rel = props.rel,
      role = props.role,
      tabIndex = props.tabIndex,
      target = props.target,
      to = props.to,
      truncate = props.truncate,
      truncateStringProps = props.truncateStringProps,
      underline = props.underline,
      use = props.use,
      rest = (0, _objectWithoutProperties2.default)(props, ["children", "className", "disabled", "external", "ExternalIcon", "href", "iconProps", "linkRef", "onClick", "onKeyDown", "rel", "role", "tabIndex", "target", "to", "truncate", "truncateStringProps", "underline", "use"]);

  if (process.env.NODE_ENV !== 'production') {
    if (to != null) {
      _devLogger.default.warn({
        message: "UILink: The `to` prop is a no-op. Did you mean `href`? (`to=\"" + to + "\"`)",
        key: 'UILink: to'
      });
    }
  }

  var defaultLinkRef = (0, _react.useRef)(null);
  var computedTarget = (0, _Links.getTarget)(external, target);
  var computedRel = (0, _Links.getRel)(rel, computedTarget);
  var computedRole = href ? undefined : role || 'button';
  var externalLinkIcon = external ? _react.default.createElement(ExternalIcon, (0, _extends2.default)({
    "aria-label": _I18n.default.text('salesUI.UILink.externalTitle'),
    name: "externalLink"
  }, iconProps, {
    className: (0, _classnames.default)('private-link--external__icon', iconProps && iconProps.className),
    truncated: truncate
  })) : null;

  if (process.env.NODE_ENV !== 'production') {
    (0, _Links.warnIfShouldBeExternal)(external, computedTarget, 'UILink');
  }

  var wrappedChildren = truncate ? _react.default.createElement(_UITruncateString.default, (0, _extends2.default)({
    useFlex: true,
    fixedChildren: externalLinkIcon
  }, truncateStringProps), children) : children;

  var renderedLink = _react.default.createElement("a", (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)('private-link', _LinkConstants.UNDERLINE_CLASSES[underline], _LinkConstants.USE_CLASSES[use], {
      'private-link--disabled': disabled
    }, className),
    onClick: function onClick(evt) {
      if (disabled) {
        evt.preventDefault();
        evt.stopPropagation();
      } else {
        if (_onClick) _onClick(evt);
      }
    },
    onKeyDown: function onKeyDown(evt) {
      // Simulate click on Spacebar, to emulate button behavior
      var key = evt.key;
      if (_onKeyDown) _onKeyDown(evt);
      if (!_onClick) return; // Ignore keydown events that bubbled up

      if (evt.target !== (linkRef || defaultLinkRef).current) return;

      if (key === ' ') {
        if (disabled) {
          evt.preventDefault();
          evt.stopPropagation();
          return;
        }

        _onClick(evt); // Prevent scrolling


        evt.preventDefault();
      }
    },
    href: disabled ? undefined : (0, _UnsafeUrl.getSafeUrl)(href),
    ref: linkRef || defaultLinkRef,
    rel: computedRel,
    role: computedRole,
    tabIndex: (0, _TabIndex.getTabIndex)(disabled, tabIndex),
    target: computedTarget,
    "aria-disabled": disabled
  }), wrappedChildren, truncate ? null : externalLinkIcon);

  return (0, _Links.renderSecurityTaggedLink)(href, renderedLink);
});
UILink.propTypes = {
  children: _propTypes.default.node,
  disabled: _propTypes.default.bool,
  external: _propTypes.default.bool.isRequired,
  ExternalIcon: _propTypes.default.elementType.isRequired,
  href: _validHref.default,
  iconProps: _propTypes.default.object,
  linkRef: _refObject.default,
  onKeyDown: _propTypes.default.func,
  rel: _propTypes.default.string,
  target: _propTypes.default.string,
  truncate: _propTypes.default.bool.isRequired,
  truncateStringProps: _propTypes.default.object,
  underline: _propTypes.default.bool.isRequired,
  use: _propTypes.default.oneOf(Object.keys(_LinkConstants.USE_CLASSES)).isRequired
};
UILink.defaultProps = {
  external: false,
  ExternalIcon: DefaultExternalIcon,
  truncate: false,
  underline: false,
  use: 'dark'
};
var _default = UILink;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/link/UILink.js
// module id = 38
// module chunks = 209 210 211 212